module.exports = __webpack_public_path__ + "static/media/award_red.677fdc64.svg";